<style>
    @import "labelTip.less";
</style>
<template>
    <span  class="label-tip" v-bind:style="theme">{{content}}</span>
</template>

<script>
    export default {
        props:{
            //提示内容
            content : '',
            //手动设置样式
            theme : {},
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/labelTip/labelTip.vue